import fetchUrl from 'utils/fetch';

export const createContent = (pageId, platform) =>
  fetchUrl(`/catalog/pages.json/${pageId}/content?platform=${platform.code}`, {
    headers: {
      Accept: 'application/json',
    },
    method: 'POST',
  }).then(res => res.json());



// WEBPACK FOOTER //
// ./src/modules/catalog/api/contents.js